// extracted by mini-css-extract-plugin
export default {"paginationTwo":"paginationTwo_paginationTwo__RKdOi","btn_bar":"paginationTwo_btn_bar__U9rek"};